import { ProgramContentType } from "@/models/programcontenttype";
import { ModelValidation } from "@/models/modelvalidation";

export interface IProgramContent {
    uuid?: string | null;
    types?: string | null;
    name?: string | null;
    description?: string | null;
    setups?: string | null;
    status?: string | null;
    contentTypes?: ProgramContentType[] | null;
    inform?: ProgramContentType | null;
    engage?: ProgramContentType | null;
}

export class ProgramContent extends ModelValidation {
    public uuid!: string | null;
    public types!: string | null;
    public name!: string | null;
    public description!: string | null;
    public setups!: string | null;
    public status!: string | null;
    public contentTypes!: ProgramContentType[] | null;
    public inform!: ProgramContentType | null;
    public engage!: ProgramContentType | null;

    constructor(content: IProgramContent) {
        super();

        if (!content) {
            throw new Error("Cannot construct ProgramContent from falsey IProgramContent");
        }

        this.uuid = content.uuid || null;
        this.types = content.types || null;
        this.name = content.name || null;
        this.description = content.description || null;
        this.status = content.status || "draft",
        this.contentTypes = content.contentTypes || [];
        this.inform = content.inform || ProgramContentType.empty("inform");
        this.engage = content.engage || ProgramContentType.empty("engage");
    }

    public static empty(): ProgramContent {
        return new ProgramContent({
            engage: ProgramContentType.empty("engage"),
            inform: ProgramContentType.empty("inform")
        });
    }

    public toNewProgramContentDto(): IProgramContent | any {
        return {
            name: this.name,
            description: this.description,
            status: this.status
        };
    }

    public isDemoReady(): boolean {
        return this.status === "draft";
    }

    public get batchReady(): boolean {
        return this.engage!.status === "active"
    }

    public toUpdateProgramContentDto(): IProgramContent {
        // these wind up being the same implementation but are semantically different
        const result = this.toNewProgramContentDto();
        result.uuid = this.uuid;
        return result;
    }

    public checkValidation(): any {
        if (
            this.name && this.name!.length <= this.contentNameMaxLenth &&
            this.description && this.name!.length <= this.contentDescriptionMaxLength
        ) {
            return true;
        } else {
            return false;
        }
    }
}
